import dayjs from "dayjs";
import "dayjs/locale/nb";

dayjs.locale("nb");

type FocalPoint = {
  x: number;
  y: number;
};

type Article = {
  title: string;
  description: string;
  author?: string;
  url: string;
  image: string;
  date?: string;
  imageAlt?: string;
  focalPoint?: FocalPoint;
};

type EventListProps = {
  items: Article[];
};

export default function EventList({ items }: EventListProps) {
  return (
    <div className="event-list">
      {items.map(
        (
          { title, description, url, image, date, imageAlt, focalPoint },
          idx,
        ) => {
          const external = !!url?.match(/^https?:/);
          let imgStyle: React.CSSProperties | undefined;
          if (focalPoint?.x != null && focalPoint?.y != null) {
            const x = Math.round(focalPoint.x * 100);
            const y = Math.round(focalPoint.y * 100);
            imgStyle = {
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: `${x}% ${y}%`,
            };
          }

          return (
            <a
              key={idx}
              href={url}
              target={external ? "_blank" : undefined}
              rel={external ? "noreferrer" : undefined}
            >
              <article>
                <figure>
                  <img src={image} alt={imageAlt} style={imgStyle} />
                </figure>
                <div>
                  <h3>{title}</h3>
                  <div>{description}</div>
                  <time>{dayjs(date).format("D. MMMM")}</time>
                </div>
              </article>
            </a>
          );
        },
      )}
    </div>
  );
}
